exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".static-menu ul[data-v-346dabba] {\n  list-style: none;\n}\n.static-menu a[data-v-346dabba]::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background-color: #bdbdbd;\n}\n.static-menu a[data-v-346dabba]:hover::after,\n.static-menu .router-link-active[data-v-346dabba]::after {\n  opacity: 0;\n}\n.static-content *[data-v-346dabba]:first-of-type {\n  margin-top: 0;\n}\n", ""]);

// exports
